(ns web3.routing.query
  (:require [reagent.core :as r]
            [re-frame-simple.db :as db]
            [web3.view :as v]
            [web3.utils :as utils]
            [re-frame.core :as rf]
            [web3.routing.utils :as routing-u]
            [clojure.string :as str]
            web3.routing.history))

(defonce queries (atom {}))

(defn query-path
  ([] [:db/routers :query :data])
  ([korks]
   (into (query-path) (utils/korks->ks korks))))

(defn set-query!
  [korks v]
  (db/dispatch [:routing/nav.query (assoc-in {} (utils/korks->ks korks) v) true]))

(defn component-query-deregister
  "Deregister `component` from all paths.
  If no components are listening to path, stop syncing with re-frame."
  [k component]
  (swap! queries update k disj component)
  (when-not (seq (get @queries k))
    (db/dispatch [:routing/nav.query (dissoc (db/get-in (query-path)) k)])))

(defn component-query-register
  [k component]
  (when-not (get-in @queries [k component])
    (v/on-unmount! component ::query-deregister (partial component-query-deregister k))
    (swap! queries update k (fnil conj #{}) component)))

(defn get-query
  ([k]
   (some->> (r/current-component)
            (component-query-register k))
   (db/get-in (query-path k)))
  ([k default]
   (let [v (get-query k)]
     (when-not v
       (db/dispatch-sync [:routing/nav.query {k default} true]))
     v)))

(defn query-string
  "If query has any non-null values, returns a ?-prefixed querystring."
  [query-map]
  (some->> (reduce-kv (fn [m k v]
                        (cond-> m
                                (nil? v) (dissoc k))) query-map query-map)
           (utils/map-vals pr-str)
           (routing-u/query-string)
           (utils/some-str)
           (str "?")))

(defn replace-query [path query-string]
  (str/replace path
               #"([^?]+)(?:\?([^#]*))?(?:#(.*))?"
               (fn [[_ before query hash]]
                 (str before
                      query-string
                      (when hash (str "#" hash))))))
(rf/reg-event-fx
 :routing/nav.query
  (fn [{:keys [db]} [_ new-query merge?]]
    (let [query (get-in db (query-path))
          new-query (cond->> new-query
                             merge? (merge query))]
      (when (not= query new-query)
        {:db (assoc-in db (query-path) new-query)
         :history/replace (replace-query (routing-u/get-route)
                                         (query-string new-query))}))))